import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import { DragDropContext, DragSource, DropTarget } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import Day from './Day'

import PropTypes from 'prop-types'

import _ from 'lodash'

class Sidebar extends Component {
  static propTypes = {
    days: PropTypes.arrayOf(PropTypes.object),
    selectedDayIndex: PropTypes.number,
    onAddDay: PropTypes.func,
    onDaySelect: PropTypes.func,
    moveDay: PropTypes.func,
    getFav: PropTypes.func,
    t: PropTypes.func,
    connectDropTarget: PropTypes.func
  }

  static defaultProps = {
    days: [],
    selectedDayIndex: 0,
    onAddDay: () => ({}),
    onDaySelect: () => ({}),
    moveDay: () => ({}),
    getFav: () =>({})
  }

  constructor(props) {
    super(props)

    this.state = {
      hoveredDay: null
    }
  }

  moveDay(id) {
    const { day } = this.findDay(id)

    this.props.moveDay(day, this.state.hoveredDay)

    this.setState({
      hoveredDay: null
    })
  }

  findDay(id) {
    const index = this.props.days.findIndex(day => day.id === id)

    return {
      day: this.props.days[index],
      index
    }
  }

  renderDays() {
    return this.props.days.map((day, i) => (
      <Day
        key={i}
        index={i}
        day={day.itineraryday}
        isActive={this.props.selectedDayIndex === i}
        findDay={id => this.findDay(id)}
        moveDay={id => {
          this.moveDay(id)
        }}
        onDaySelect={index => {
          this.props.onDaySelect(index)
        }}
        setHoveredDay={hoveredDay => {
          this.setState({ hoveredDay })
        }}

        getFav= {(res) => {
          this.props.getFav(res.day.isFavorite)
        }}
      />
    ))
  }

  render() {
    return this.props.connectDropTarget(
      <div className="sidebar">
        <div className="sidebar__days">{this.renderDays()}</div>
        {/* <div className="sidebar__add-day add-day" onClick={() => this.props.onAddDay()}>
          <i className="add-day__icon icon-plus" />
          <span className="add-day__label">{this.props.t('add_day')}</span>
        </div> */}
      </div>
    )
  }
}

export default compose(
  translate('trip_planner'),
  DragDropContext(HTML5Backend),
  DropTarget('day', {}, connect => ({
    connectDropTarget: connect.dropTarget()
  }))
)(Sidebar)



// WEBPACK FOOTER //
// src/components/TripPlanner/Sidebar.js